import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    setCcRequirementPopupMenuShow,
} from "client/store"
import {
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import Open from "./open"

const Menu = () => {
    const baseRoute = useSelector((state: StoreType) => state.ccRequirement.baseReviewRoute)
    const revisionActiveList = useSelector((state: StoreType) => state.ccRequirement.revisionActiveList)
    const active = useSelector((state: StoreType) => state.ccRequirement.active)
    const menuShow = useSelector((state: StoreType) => state.ccRequirement.menuShow)
    const menuTarget = useSelector((state: StoreType) => state.ccRequirement.menuTarget)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [menuItems, setMenuItems] = useState<any[]>([])

    const hideMenu = () => {
        dispatch(setCcRequirementPopupMenuShow(false))
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const open = (
        <PopupMenuItem
            key="open"
            onClick={() => {
                if (!active) return
                const revision = revisionActiveList[active.id]
                if (!revision) return

                Open(baseRoute, active.id, revision.id, dispatch)
            }}
        >
            {lang.open}
        </PopupMenuItem>
    )

    useEffect(() => {
        const menu: any[] = []
        menu.push(open)

        setMenuItems(menu)
    }, [active])


    if (!menuItems.length) return null
    return (
        <PopupMenu
            show={menuShow}
            target={menuTarget}
            placement="right"
        >
            {menuItems}
        </PopupMenu>
    )
}

export default Menu
